import axios from 'axios'
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

import config from '../config'
const apiPath = config.apiPath
const origDomain = config.origDomain

import { getSid } from '../helpers/session'

export default function api(url,params,formData,onProgress, useOrigDomain) {
  params = params || {}
  let sid = typeof params.sid == "undefined" ? getSid() : params.sid;
  let headers = {};
  headers["Authorization"] = sid;

  var fullUrl = apiPath+"/"+url;
  if (useOrigDomain) {
    fullUrl = origDomain+fullUrl
  }
  let source = CancelToken.source();
  // params.cancelToken = source.token
  let timeout = setTimeout(()=> {
    console.log("api timeout:",{fullUrl,params})
  }, 2000)
  var data = params;

  if (formData) {
    data = new FormData();
    for (let key in params) {
      data.append(key,params[key])
    }
    headers["content-type"] = 'multipart/form-data';
  }

  let config = {
    url: fullUrl,
    method: "post",      
    data: data,
    headers: headers,
    cancelToken: source.token
  }
  if (typeof onProgress == 'function') {
    config.onUploadProgress = (e)=>{
      onProgress(e,Math.floor((e.loaded * 100) / e.total));
    } 
  }

  let startTime = Date.now()
  let request = axios(config)
    .then(function (response) {
      clearTimeout(timeout);
      const data = response.data;
      let now = Date.now()
      console.log("("+(now-startTime)+"ms)api:",{fullUrl,params,data})
      if (!data) {
        throw new Error("no data received");
      }
      if (typeof data == "string") {
        console.warn(response)
        console.warn(config)
        throw new Error(data);
      }
      if (data.log) {
        console.info("api log:");
        for (var i = 0; i < data.log.length; i++) {
          console.info(data.log[i])
        }
      }
      if (data.error) {
        throw new Error(data.error);
      }
      if (!data.data) {
        throw new Error("bad response");        
      }      
      return data.data
    }).catch(function (error) {   
      clearTimeout(timeout);   
      if (axios.isCancel(error)) {
        console.log("api canceled:",{fullUrl,params,error,request});
        return "canceled";
      } else {
        console.log("api error:",{fullUrl,params,error,request});
        console.warn(error);    
      }
      return {error}
    });   
  request.cancel = function() {
    console.log("cancelling request",{fullUrl,params})
    source.cancel()
  } 
  return request;      
}